import { animate, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { API, DeviceFullDTO, FileLink } from 'src/app/services/api/api';
import { ModalNavigationComponent } from 'src/app/services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from 'src/app/services/gui/modal/modal-navigation.service';
import { UtilService } from 'src/app/services/util.service';
import { ErrorService } from '../../../../services/error.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-comp-device-playlist-download',
  templateUrl: './sb-device-playlist-download.component.html',
  styleUrls: ['./sb-device-playlist-download.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SbDevicePlaylistDownloadComponent implements OnInit, ModalNavigationComponent {
  loading: boolean;

  isInModalContext: boolean;

  @Input()
  device: DeviceFullDTO;

  preselectType?: string;

  selType: string = 'Neon';

  constructor(
    private api: API,
    private errorHandler: ErrorService,
    private modalNavigation: ModalNavigationService,
    public util: UtilService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  goBack() {
    this.modalNavigation.goBack();
  }

  selectedType($event: string) {
    this.selType = $event;
  }

  download() {
    this.loading = true;
    switch (this.selType) {
      case 'Neon':
        this.api
          .ss_nm_Device_retrieveOfflinePlaylistNeon(this.device.id)
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            take(1),
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe({
            next: (data: FileLink) => {
              this.util.downloadFileLink(data);
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
        break;

      case 'Smil':
        this.api
          .ss_nm_Device_retrieveOfflinePlaylistSMIL(this.device.id)
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            take(1),
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe({
            next: (data: FileLink) => {
              this.util.downloadFileLink(data);
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
        break;
    }
  }
}
